(function ($) {

'use strict';

	/**
	 * fix the footer layout for IE
	 * @returns {undefined}
	 */
	function IEFooterFix() {
		if ($.isIE() === true) {
			var windowHeight = $(window).height();
			var mainHeight = windowHeight -
					$('header').outerHeight(true) -
					$('footer').outerHeight(true);

			var $temp = $('#main');
			if ($temp.lenth > 0) {
				mainHeight -= $temp.outerHeight(true) - $temp.height();
			}

			$temp = $('header + h2');
			if ($temp.length > 0) {
				mainHeight -= $temp.outerHeight(true);
			}

			$('#main').css('min-height', mainHeight);
		}
	} // IEFooterFix

	$.installResizeHanlder = function () {
		var documentWidth = 0;
		var resizeTimer = 0;
		var resizeActive = false;

		function resizeHandler() {

			/**
			 * Set the focus to the nav button if an element outside the menu has it
			 * @returns {undefined}
			 */
			function menuTabOrderFix() {
				if ($('#mainmenu').is(':visible')) {
					$('.nav-btn').focus();
				}
			}

			if (resizeActive) {
				clearTimeout(resizeTimer);
				resizeTimer = setTimeout(100, resizeHandler);
				return;
			}

			if (documentWidth === $(document).width()) {
				return;
			}

			resizeActive = true;

			documentWidth = $(document).width();

			$(document).off('click.menuexit');
			var $menus = $('#mainmenu, #submenu');

			IEFooterFix();

			// select ul elements with attribute "data-xrespmenu-idx"
			var $responsiveMenus = $('ul[data-respmenu-idx]');
			if ($responsiveMenus.length > 0) {
				$responsiveMenus.sortElements(function (a, b) {
					return ($(a).attr('data-respmenu-idx').toUpperCase() > $(b).attr('data-respmenu-idx').toUpperCase() ? 1 : -1);
				});
			}

			// displaying or hiding menu on layout change
			// subtracting scrollbar width from the defined breakpoint
			var checkWidth = $.morejs_options.responsiveMenuConfig.breakPointWidth;

			// CSS Media Query width == window.innerWidth
			if (window.innerWidth >= checkWidth && $('.nav-btn').attr('data-pinned') !== '1') {
				$menus.show();
				$('#mainmenu').closest('nav').find('a.nav-btn').remove();
				$('#mainmenu li:not(.submenu-parent) > a').off('click');

				$responsiveMenus.each(function () {
					// replace the placeholder with the menu ul element and remove it from the mainmenu
					if ($(this).is('[data-rmid]')) {
						var $respMenuParent = $(this).closest('.submenu-parent');
						var $respMenu = $(this).detach();
						$respMenuParent.remove();
						$('#' + $respMenu.attr('data-rmid')).replaceWith($respMenu);
						$respMenu.removeAttr('data-rmid');
					}
				});
				$responsiveMenus.parent().removeClass('resp-child-hidden');


				$('input, a:not(.nav-btn):not(#mainmenu li a)').off('focus', menuTabOrderFix);
			} else {
				if ($('#mainmenu').closest('nav').find('a.nav-btn').length < 1) {
					var menuText = $.i81n.text('MENU');
					$('#mainmenu').closest('nav').prepend('<a class="nav-btn" accesskey="n" href="javascript:;" title="' + menuText + '">' + menuText + '</a>');
					$('.nav-btn').setAccessKey('n');

					$responsiveMenus.parent().addClass('resp-child-hidden');

					var respMenuCount = 0;
					$responsiveMenus.each(function () {
						if (!$(this).is('[data-rmid]')) {
							// replace the menu ul element with a placeholder element and append it to the mainmenu
							var respid = 'rm' + (++respMenuCount);
							var $respMenu = $(this).replaceWith($('<div id="' + respid + '" style="display:none"/>'));
							$respMenu.attr('data-rmid', respid);
							$('#mainmenu').append($('<li class="submenu-parent"/>').append($respMenu));
						}
					});


					if(!('disableFocusMenuOrder' in $.morejs_options) || $.morejs_options.disableFocusMenuOrder === false){
						$('input, a:not(.nav-btn):not(#mainmenu li a)').off('focus.menuorder').on('focus.menuorder', menuTabOrderFix);
					}
				}
				$('.nav-btn').show();
				$menus.hide();
			}

			setTimeout($.initMenuClickHandler, 10);

			resizeActive = false;
		}

		/**
		 * Resize handler process needed stly changes
		 */
		$(window).on('resize.main', function () {
			clearTimeout(resizeTimer);
			resizeTimer = setTimeout(resizeHandler, 10);
		});

	}; // $.installResizeHanlder

}(jQuery));